export default (function (str) {
  return str.split(/[:\s+]/);
});


// WEBPACK FOOTER //
// ./dist/lib/get-groups.js